import type { ReactNode } from 'react';

/**
 * 移动画幅容器 · 学生端为移动优先设计
 *
 * 在平板/桌面等宽屏上，把学生端内容约束为一个居中的手机宽度列（约 480px），
 * 两侧留出中性底色，像一个手机画幅；窄屏（手机）下即为全宽，无副作用。
 *
 * 结构（关键）：
 *   外层 gutter（居中 + 深色底）
 *     画幅盒子 frame —— `transform: translateZ(0)` 建立 containing block，且**固定一屏高、自身不滚动**
 *       滚动层 scroller —— `overflow-y: auto`，承载页面内容的滚动
 *         {children}
 *
 * 为什么这样能两全：
 *  - `transform` 让 frame 成为页面内 `position: fixed` 元素（底部导航、背景图、设置抽屉）的
 *    containing block → 它们被裁在 480 画幅内（宽屏下不外溢）。
 *  - 滚动发生在**内层 scroller**、frame 本身不滚动 → fixed 元素相对 frame 定位时不会跟着内容滚走，
 *    稳稳钉在画幅可视区域（背诵页等超长页面也不必滑到底才看到导航；设置抽屉不会开在屏幕外）。
 *  曾经的坑：把 overflow 直接放在 frame（transform 元素）上当滚动容器，fixed 子元素会被当成
 *  absolute 跟着内容滚动 —— 所以滚动必须放在内层，而非 frame 自身。
 */
export default function MobileFrame({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        height: '100dvh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        background: '#10171F',
      }}
    >
      <div
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: 480,
          height: '100dvh',
          transform: 'translateZ(0)',
          overflowX: 'hidden',
          boxShadow: '0 0 48px rgba(0,0,0,0.20)',
        }}
      >
        <div style={{ height: '100%', overflowY: 'auto' }}>
          {children}
        </div>
      </div>
    </div>
  );
}
